import {toast} from "react-toastify";
import {getCookie} from "react-use-cookie";
import {t} from "i18next";

import {instance} from "../api/apiSetup";
import {checkEmptyFields} from "../utilities/checkEmptyFields";
import {ERROR} from "../utilities/generalConstants.js/generalConstants";
import {toaster} from "../utilities/hooks/toaster";
import toastInstance from "../utilities/ToastManager";

export const fetchData = async (
  url,
  method,
  rawBody = null,
  headers = null,
  withoutError = false,
  params = null,
  noMessage = false,
) => {
  const isNotLoginRequest = url !== "/auth/login" && url !== "/users/changePass";
  const isToken = getCookie("access_token");
  if (isNotLoginRequest && !isToken) return;

  const config = {
    headers,
    params,
  };

  const body = method.toUpperCase() === "POST" ? checkEmptyFields(rawBody) : rawBody;

  const response = await instance[method](url, body, config)
    .then(res => {
      if (!res.data) return;
      !noMessage && res.data.message && toast.info(t(res.data.message), {autoClose: 1000});
      return res.data;
    })
    .catch(err => {
      if (err === ERROR.TOKEN) {
        console.error(err);
        return;
      }
      if (err?.code === ERROR.CANCELED) return; //for aborted fetch via AbortController
      if (err.response?.status === 401) {
        toastInstance.showError(t(err.response.data.message), {autoClose: 1000}, err.response?.status);
      } else if (!withoutError) toast.error(t(err.response?.data?.message), 2000);
      // throw new Error(err.response?.data?.message);

      console.error(err);
      // toaster.error(`Fetch error: ${t(err.response?.data?.message)}`, 2000);
      // return err;
    });
  return response;
};

export const fetchDataNew = async (
  url,
  method,
  {
    rawBody = null,
    body = null, //the same as rawBody
    headers = null,
    withoutError = false,
    params = null,
    noMessage = false,
    rejectWithValue = () => {},
    signal,
  } = {},
) => {
  const isNotLoginRequest = url !== "/auth/login" && url !== "/users/changePass";
  const isToken = getCookie("access_token");
  if (isNotLoginRequest && !isToken) return;

  const config = {
    headers,
    params,
    signal,
  };

  const bodyData = rawBody || body;
  const bodyProcessed = method.toUpperCase() === "POST" ? checkEmptyFields(bodyData) : bodyData;

  const requestPromise =
    method.toUpperCase() === "GET" || method.toUpperCase() === "DELETE"
      ? instance[method](url, config)
      : instance[method](url, bodyProcessed, config);

  const response = await requestPromise
    .then(res => {
      if (!res.data) return;
      !noMessage && res.data.message && toast.info(t(res.data.message), {autoClose: 1000});
      return res.data;
    })
    .catch(err => {
      if (err === ERROR.TOKEN) {
        console.error(err);
        return;
      }
      if (err?.code === ERROR.CANCELED) return; //for aborted fetch via AbortController
      if (err.response?.status === 401) {
        toastInstance.showError(t(err.response.data.message), {autoClose: 1000}, err.response?.status);
      } else !withoutError && toaster.error(`Fetch error: ${t(err.response?.data?.message)}`, 2500);
      return rejectWithValue(`Fetch error: ${t(err.response?.data?.message)}`);
    });
  return response;
};

export const fetchList = async (url, method = "get", body = null) => {
  const isToken = getCookie("access_token");
  if (!isToken) return;

  const response = await instance[method](url, body)
    .then(res => {
      if (!res.data) return;
      return res.data;
    })
    .catch(err => {
      if (err === ERROR.TOKEN) {
        console.error(err);
        return;
      }
      if (err?.code === ERROR.CANCELED) return; //for aborted fetch via AbortController
      if (err?.response?.status === 401) {
        toastInstance.showError(t(err?.response?.data.message), {autoClose: 1000}, err.response?.status);
      }
      // throw new Error(err?.response?.data?.message);
      console.error(err);
      toaster.error(`Fetch error: ${t(err.response?.data?.message)}`, 2500);
    });
  return response;
};

//use this
export const fetchListNew = async (
  url,
  method = "get",
  {rawBody = {}, rejectWithValue = () => {}, withoutError, params = {}, signal} = {},
) => {
  const isToken = getCookie("access_token");
  if (!isToken) return;

  const response = await instance[method](url, {signal, params, ...rawBody})
    .then(res => {
      if (!res.data) return;
      return res.data;
    })
    .catch(err => {
      if (err === ERROR.TOKEN) {
        console.error(err);
        return;
      }
      if (err?.code === ERROR.CANCELED) return; //for aborted fetch via AbortController
      if (err?.response?.status === 401) {
        toastInstance.showError(t(err?.response?.data.message), {autoClose: 1000}, err.response?.status);
      } else !withoutError && toaster.error(`Fetch error: ${t(err.response?.data?.message)}`, 2000);
      console.error(err);
      return rejectWithValue(`Fetch error: ${t(err.response?.data?.message)}`);
    });

  return response;
};

export const deleteReq = async (url, body = null, headers = null, noMessage = false) => {
  const isToken = getCookie("access_token");
  if (!isToken) return;

  const response = await instance
    .delete(url, {headers, data: body})
    .then(res => {
      !noMessage && toast.info(res.data.message, {autoClose: 1000});
      return res.data;
    })
    .catch(err => {
      if (err === ERROR.TOKEN) {
        console.error(err);
        return;
      }
      toast.error(err.response.data.message);
      throw new Error(err.response.data.message);
    });
  return response;
};

export const fetchData_ = async (
  url,
  method,
  rawBody = null,
  settings = {data: null, headers: null, params: null, withoutError: false, noMessage: false},
) => {
  const isToken = getCookie("access_token");
  if (!isToken) return;

  const {headers, params, withoutError, noMessage} = settings;
  const config = {
    headers,
    params,
  };

  const body = method.toUpperCase() === "POST" ? checkEmptyFields(rawBody) : rawBody;

  const response = await instance[method](url, body, config)
    .then(res => {
      !noMessage && res.data.message && toast.info(t(res.data.message), {autoClose: 1000});
      return res.data;
    })
    .catch(err => {
      if (err === ERROR.TOKEN) {
        console.error(err);
        return;
      }
      if (err.response?.status === 401) {
        toastInstance.showError(err.response.data.message, {autoClose: 1000}, err.response?.status);
      } else if (!withoutError) toast.error(t(err.response.data.message));
      throw new Error(err.response.data.message);
      // return err;
    });
  return response;
};
